import React from "react";

export const ThemeModeContext = React.createContext({
    toggleThemeMode: () => {
        // This is intentional
    },
});
